/*
 * @Author: your name
 * @Date: 2020-10-20 10:25:41
 * @LastEditTime: 2020-11-24 11:33:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/utils/webSocket/wsConfig.js
 * 直接this.WebSocket.XXX生成链接，返回promise 为true
 * 若需要参数，this.WebSocket.XXX（params）
 * 调用this.WebSocket.XXX.get方法获得连接或连接组
 * 调用this.WebSocket.getAll返回所有连接
 */
const WebSocketConfig = {
  useWebSocket: true,
  // 是否开启websocket

  /**
   * name:连接标识，名称
   * url:连接路径
   * size:连接数量，可选，默认为1
   */
  webSocketList: [{
    name: 'general',
    url: '/websocket',
    optionList: {
      auth: {
        resOp: 'NETTY_AUTH_REQ'
      },
      // 权限
      heartBreak: {
        resOp: 'NETTY_HEART_BEAT_REQ'
      },
      // 心跳
      // 做题
      getPaper: {
        resOp: 'paper_questions_v2'
      },
      // 获取做题信息
      review: {
        resOp: 'review'
      },
      // 错题回顾
      submitOne: {
        resOp: 'submit_question'
      },
      // 提交单题答案
      pause: {
        resOp: 'pause'
      },
      // 暂停答题
      resume: {
        resOp: 'resume'
      },
      // 继续答题
      mark: {
        resOp: 'mark'
      },
      // 标记
      sign: {
        resOp: 'sign'
      },
      // 收藏
      switch: {
        resOp: 'switch_question'
      },
      // 切换
      submit: {
        resOp: 'submit'
      },
      // 交卷
      close: {
        resOp: 'close'
      },
      // 账号已登录
      // 直播
      'NETTY_LIVE_IN_REQ': {
        resOp: 'NETTY_LIVE_IN_REQ'
      },
      // 直播
      'NETTY_REPLAY_IN_REQ': {
        resOp: 'NETTY_REPLAY_IN_REQ'
      },
      // 直播
      // 登录相关
      login: {
        resOp: 'NETTY_LOG_ON_REQ'
      },
      // 登录成功
      loginOut: {
        resOp: 'NETTY_LOG_OFF_REQ'
      },
      // 退出登录
      // 监听session
      channel: {
        resOp: 'channel_info'
      } // 监听session返回

    }
  }]
};
export default WebSocketConfig;